<template>
  <div class="page flex-col">
    <!-- 页面主容器 -->
    <div class="group_1 flex-row">
      <div class="group_2 flex-col">
        <!-- 公共头部组件 -->
        <PageHeader />

        <!-- ==================== banner 图区域 ==================== -->
        <img
          class="banner"
          src="https://image.cbrand.com.cn/default/2026/10/6F5F3770BCDB44888456B422961B783B.jpg"
          alt="电子杂志 banner"
        />

        <!-- ==================== 年份切换区域 ==================== -->
        <div class="year-tabs">
          <div
            v-for="(year, index) in years"
            :key="index"
            class="year-tab"
            :class="{ active: activeYear === year }"
            @click="switchYear(year)"
          >
            {{ year }}
          </div>
        </div>

        <!-- ==================== 电子杂志列表区域 ==================== -->
        <div class="magazine-list">
          <!-- 加载中骨架屏 -->
          <div v-if="loading" class="skeleton-list">
            <div
              v-for="n in pageSize"
              :key="'skeleton-' + n"
              class="magazine-item skeleton-item"
            >
              <!-- 封面骨架 -->
              <div class="skeleton-cover skeleton-anim"></div>

              <!-- 内容骨架 -->
              <div class="magazine-main">
                <div class="skeleton-title skeleton-anim"></div>
                <div class="skeleton-row-group">
                  <div class="skeleton-row skeleton-anim"></div>
                  <div class="skeleton-row skeleton-anim"></div>
                  <div class="skeleton-row skeleton-anim"></div>
                </div>
                <div class="skeleton-brand-title skeleton-anim"></div>
                <div class="skeleton-brand-list">
                  <div class="skeleton-brand skeleton-anim"></div>
                  <div class="skeleton-brand skeleton-anim"></div>
                  <div class="skeleton-brand skeleton-anim"></div>
                </div>
              </div>

              <!-- 右侧按钮骨架 -->
              <div class="magazine-side">
                <div class="skeleton-btn skeleton-anim"></div>
              </div>
            </div>
          </div>

          <!-- 无数据提示 -->
          <div v-else-if="magazineList.length === 0" class="empty-tip">
            <div class="empty-box"></div>
            <span class="empty-text">本年度无数据</span>
          </div>

          <!-- 真实数据 -->
          <template v-else>
            <div
              v-for="(item, index) in visibleList"
              :key="index"
              class="magazine-item"
            >
              <!-- 封面图 -->
              <img
                class="magazine-cover"
                style="cursor: pointer;"
                :src="item.cover && item.cover.indexOf('http') === 0 ? item.cover : require('./assets/img/' + item.cover)"
                :alt="item.issue"
                @click="goToViewer(item.emagazineCode)"
              />

              <!-- 杂志主要内容区 -->
              <div class="magazine-main">
                <div class="magazine-issue">{{ item.name }}</div>

                <div
                  v-for="(row, rowIndex) in item.catalogRows"
                  :key="rowIndex"
                  class="catalog-row"
                >
                  <div
                    v-for="(catalog, cIndex) in row"
                    :key="cIndex"
                    class="catalog-cell"
                    :class="{ empty: !catalog }"
                    @click="goToViewer(item.emagazineCode, catalog?.turnPage)"
                  >
                    <div v-if="catalog" class="catalog-tag">
                      {{ catalog.tag }}
                    </div>
                    <span v-if="catalog" class="catalog-name">
                      {{ catalog.name }}
                    </span>
                  </div>
                </div>

                <div class="brand-title">本期品牌</div>
                <div class="brand-list">
                  <div
                    v-for="(brand, bIndex) in item.brands"
                    :key="bIndex"
                    class="brand-item"
                  >
                    <span class="brand-text">{{ brand }}</span>
                  </div>
                </div>
              </div>

              <!-- 右侧购买入口 -->
              <div class="magazine-side">
                <button class="buy-button" @click="buyMagazine(item)">
                  <div class="buy-icon-wrap">
                    <img
                      class="buy-icon"
                      :src="require('./assets/img/FigmaDDSSlicePNGe33a219e051a93b05a0120edae93dedf.png')"
                      alt="购买"
                    />
                  </div>
                  <span class="buy-text">购买杂志</span>
                </button>
              </div>
            </div>
          </template>
        </div>

        <!-- 加载更多 -->
        <div
          v-if="!loading && visibleCount < magazineList.length"
          class="load-more"
          @click="loadMore"
        >
          <img
            class="load-more-icon"
            :src="require('./assets/img/FigmaDDSSlicePNGb212023b2c0c6c18e49d7afd472dbd20.png')"
            alt="加载更多"
          />
          <span class="load-more-text">点击加载更多</span>
        </div>

        <!-- 公共底部组件 -->
        <PageFooter />
      </div>
    </div>

    <!-- 购买弹窗 -->
    <div v-if="showBuyDialog" class="mag-buy-dialog-overlay" @click.self="closeBuyDialog">
      <!-- 步骤1：选择页面 -->
      <transition name="mag-dialog-fade">
        <div v-if="buyStep === 1" class="mag-buy-dialog mag-buy-dialog-select">
          <div class="mag-dialog-header">
            <h3>{{ buyProductTitle }}</h3>
          </div>
          <div class="mag-dialog-content">
            <!-- 选择类型 -->
            <div class="mag-select-section">
              <label class="mag-label">请选择您购买的类型：</label>
              <div class="mag-radio-group">
                <label class="mag-radio-item">
                  <input type="radio" value="本期" v-model="productType" @change="calculateTotalPrice">
                  <span class="mag-radio-text">本期</span>
                </label>
                <label class="mag-radio-item">
                  <input type="radio" value="年刊" v-model="productType" @change="calculateTotalPrice">
                  <span class="mag-radio-text">年刊</span>
                </label>
              </div>
            </div>
            <div class="mag-select-section">
              <label class="mag-label">杂志类型：</label>
              <div class="mag-radio-group">
                <label class="mag-radio-item">
                  <input type="radio" value="physical" v-model="purchaseItemType" @change="calculateTotalPrice">
                  <span class="mag-radio-text">纸质版本</span>
                </label>
              </div>
            </div>

            <!-- 单本金额 -->
            <div class="mag-info-row">
              <span class="mag-info-label">单本金额：</span>
              <span class="mag-info-value">¥{{ unitPrice.toFixed(2) }}</span>
            </div>

            <!-- 购买数量 -->
            <div class="mag-quantity-section">
              <label class="mag-label">购买数量：</label>
              <div class="mag-quantity-control">
                <button class="mag-qty-btn" @click="handleQuantityChange(-1)" :disabled="quantity <= 1">-</button>
                <span class="mag-qty-value">{{ quantity }}</span>
                <button class="mag-qty-btn" @click="handleQuantityChange(1)" :disabled="quantity >= 99">+</button>
              </div>
            </div>

            <!-- 支付金额 -->
            <div class="mag-total-section">
              <label class="mag-total-label">支付金额：</label>
              <span class="mag-total-value">¥{{ formattedTotalPrice }}</span>
            </div>

            <!-- 运费提示 -->
            <div class="mag-shipping-tip">邮政配送免运费</div>

            <!-- 收货人信息 -->
            <div class="mag-address-section">
              <!-- 收货人姓名 -->
              <div class="mag-input-row">
                <label class="mag-label">收货人姓名：</label>
                <input
                  type="text"
                  v-model="receiverName"
                  placeholder="请输入收货人姓名"
                  maxlength="20"
                  class="mag-input-text"
                />
              </div>

              <!-- 手机号码 -->
              <div class="mag-input-row">
                <label class="mag-label">手机号码：</label>
                <input
                  type="tel"
                  v-model="receiverPhone"
                  placeholder="请输入手机号码"
                  maxlength="11"
                  class="mag-input-text"
                  @input="validatePhone"
                />
              </div>

              <!-- 所在地区 -->
              <div class="mag-district-section">
                <label class="mag-label">所在地区：</label>
                <div class="mag-district-row">
                  <select
                    v-model="receiverProvince"
                    class="mag-district-select"
                    @change="onProvinceChange"
                  >
                    <option value="">选择省份</option>
                    <option
                      v-for="province in provinceList"
                      :key="province.value"
                      :value="province.value"
                    >
                      {{ province.label }}
                    </option>
                  </select>

                  <select
                    v-model="receiverCity"
                    class="mag-district-select"
                    :disabled="!receiverProvince"
                    @change="onCityChange"
                  >
                    <option value="">选择城市</option>
                    <option
                      v-for="city in cityList"
                      :key="city.value"
                      :value="city.value"
                    >
                      {{ city.label }}
                    </option>
                  </select>

                  <select
                    v-model="receiverDistrict"
                    class="mag-district-select"
                    :disabled="!receiverCity"
                  >
                    <option value="">选择区县</option>
                    <option
                      v-for="district in districtList"
                      :key="district.value"
                      :value="district.value"
                    >
                      {{ district.label }}
                    </option>
                  </select>
                </div>

                <!-- 限制配送地区提示（新疆、西藏） -->
                <div class="mag-warning-text" v-if="isRestrictedRegion">
                  新疆、西藏地区暂不支持配送
                </div>
              </div>

              <!-- 详细地址 -->
              <div class="mag-input-row mag-input-row-textarea">
                <label class="mag-label">详细地址：</label>
                <textarea
                  v-model="receiverAddress"
                  placeholder="请输入详细地址"
                  maxlength="100"
                  rows="3"
                  class="mag-input-textarea"
                ></textarea>
              </div>
            </div>

            <!-- 立即支付按钮 -->
            <button
              class="mag-pay-btn"
              :disabled="payLoading || isRestrictedRegion"
              @click="handlePayClick"
            >
              {{ payLoading ? '正在创建订单...' : '立刻支付' }}
            </button>
          </div>
        </div>
      </transition>

      <!-- 步骤2：支付页面 -->
      <transition name="mag-dialog-fade">
        <div v-if="buyStep === 2" class="mag-buy-dialog mag-buy-dialog-pay">
          <div class="mag-dialog-header">
            <h3>{{ buyProductTitle }}</h3>
          </div>
          <div class="mag-dialog-content">
            <div class="mag-order-summary">
              <p>{{ paymentSummary }}</p>
            </div>
            <div class="mag-qrcode-container">
              <div class="mag-qrcode-box" ref="qrcodeContainer">
                <div v-if="!orderNo" class="mag-qrcode-placeholder">
                  <span>正在生成二维码...</span>
                </div>
              </div>
              <div class="mag-pay-tip">请用微信扫码支付</div>
              <div class="mag-pay-tip" v-if="orderPayTipContent" v-html="orderPayTipContent"></div>
              <div class="mag-pay-amount">¥{{ formattedTotalPrice }}</div>
            </div>
            <button class="mag-back-btn" @click="buyStep = 1">返回</button>
          </div>
        </div>
      </transition>

      <!-- 步骤3：支付成功页面 -->
      <transition name="mag-dialog-fade">
        <div v-if="buyStep === 3" class="mag-buy-dialog mag-buy-dialog-success">
          <div class="mag-dialog-content">
            <div class="mag-success-icon">
              <svg viewBox="0 0 24 24" width="72" height="72">
                <circle cx="12" cy="12" r="11" fill="none" stroke="#52c41a" stroke-width="2"/>
                <path d="M7 12l3 3 7-7" fill="none" stroke="#52c41a" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h3 class="mag-success-title">支付成功</h3>
            <p class="mag-success-desc">
              您已经支付成功，可以去
              <span class="mag-success-link" @click="goToMyOrders">个人中心</span>
              查看电子杂志订单
            </p>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import PageHeader from '../detail/components/PageHeader.vue'
import PageFooter from '../detail/components/PageFooter.vue'
import { fetchMagazineList, fetchYearList } from '../../api'
import { request } from '../../api/request'
// 引入完整省市区数据
import { regionData } from 'element-china-area-data'

export default {
  name: 'LanhuNewDianZiZaZhi',
  components: {
    PageHeader,
    PageFooter
  },
  data() {
    return {
      // 可选年份列表（从接口获取）
      years: [],
      // 当前选中的年份
      activeYear: null,
      // 每次加载的条数
      pageSize: 12,
      // 当前已展示的条数
      visibleCount: 12,
      // 电子杂志数据列表
      magazineList: [],
      // 列表加载状态
      loading: false,

      // ===== 购买弹窗相关 =====
      showBuyDialog: false,
      buyStep: 1,
      currentMagazine: null,
      productType: '本期',
      purchaseItemType: 'physical',
      unitPrice: 0,
      singleDigitalPrice: 0,
      singlePrintPrice: 0,
      subscriptionDigitalPrice: 0,
      subscriptionPrintPrice: 0,
      quantity: 1,
      totalPrice: 0,
      payLoading: false,
      orderNo: '',
      timer: null,

      // ===== 收货人信息 =====
      receiverName: '',
      receiverPhone: '',
      receiverAddress: '',
      receiverProvince: '',
      receiverCity: '',
      receiverDistrict: '',

      // ===== 省市区数据（完整） =====
      regionData: regionData,
      provinceList: [],
      cityList: [],
      districtList: [],

      restrictedRegions: ['54', '65'], // 西藏、新疆
      orderPayTipContent: '',
    }
  },
  computed: {
    visibleList() {
      return this.magazineList.slice(0, this.visibleCount)
    },
    buyProductTitle() {
      if (!this.currentMagazine) return ''
      const issue = this.currentMagazine.issueNumber < 10
        ? `0${this.currentMagazine.issueNumber}`
        : this.currentMagazine.issueNumber
      return `${this.currentMagazine.year}年第${issue}期`
    },
    paymentSummary() {
      let text = ''
      if (this.productType === '本期') {
        text += `本期 * ${this.quantity} 本`
      } else {
        text += `年刊 * ${this.quantity}`
      }
      if (this.purchaseItemType === 'physical') {
        text += ' 纸质版本'
      } else {
        text += ' 电子版本'
      }
      return text
    },
    formattedTotalPrice() {
      return this.totalPrice.toFixed(2)
    },
    effectiveUnitPrice() {
      if (this.productType === '本期') {
        return this.purchaseItemType === 'physical' ? this.singlePrintPrice : this.singleDigitalPrice
      } else {
        return this.purchaseItemType === 'physical' ? this.subscriptionPrintPrice : this.subscriptionDigitalPrice
      }
    },
    isRestrictedRegion() {
      return this.restrictedRegions.includes(this.receiverProvince)
    },
    provinceName() {
      const p = this.provinceList.find(item => item.value === this.receiverProvince)
      return p ? p.label : ''
    },
    cityName() {
      const c = this.cityList.find(item => item.value === this.receiverCity)
      return c ? c.label : ''
    },
    districtName() {
      const d = this.districtList.find(item => item.value === this.receiverDistrict)
      return d ? d.label : ''
    }
  },
  created() {
    // 初始化省份列表
    this.provinceList = this.regionData.map(p => ({
      value: p.value,
      label: p.label
    }))

    // 加载年份和杂志列表
    this.fetchYearList().then(() => {
      if (this.activeYear) {
        this.fetchMagazineList()
      }
    })
    this.showOrderPayTipInfo()
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  methods: {
    // ==================== 年份与列表 ====================
    async fetchYearList() {
      try {
        const list = await fetchYearList()
        if (list && list.length > 0) {
          this.years = [...list].sort((a, b) => b - a).map(year => `${year}年`)
          this.activeYear = this.years[0]
        }
      } catch (e) {
        console.error('年份列表加载失败', e)
      }
    },
    switchYear(year) {
      this.activeYear = year
      this.visibleCount = this.pageSize
      this.fetchMagazineList()
    },
    async fetchMagazineList() {
      if (!this.activeYear) return
      this.loading = true
      try {
        const year = parseInt(this.activeYear)
        const list = await fetchMagazineList(year)
        this.magazineList = list.map(item => this.formatMagazineItem(item))
        this.visibleCount = this.pageSize
      } catch (e) {
        console.error('杂志列表加载失败', e)
      } finally {
        this.loading = false
      }
    },
    formatMagazineItem(item) {
      const navList = (item.navList || []).map(nav => ({
        tag: nav.navTypeName || '',
        name: nav.navName || '',
        turnPage: nav.turnPage
      }))

      const requiredRows = Math.ceil(navList.length / 3)
      const maxRows = Math.max(3, requiredRows)

      const catalogRows = []
      for (let i = 0; i < maxRows; i++) {
        const rowCells = Array.from({ length: 3 }, (_, idx) => {
          const cellIndex = i * 3 + idx
          return cellIndex < navList.length ? navList[cellIndex] : null
        })
        catalogRows.push(rowCells)
      }

      return {
        id: item.id,
        emagazineCode: item.emagazineCode || '',
        cover: item.cover || '',
        year: item.year || 0,
        name: item.name || '',
        issueNumber: item.issueNumber || 0,
        issue: `${item.year}年第${String(item.issueNumber).padStart(2, '0')}期`,
        catalogRows,
        brands: (item.brandList || []).map(brand => brand.name || ''),
        sideTitles: (item.navList || []).slice(0, 3).map(nav => nav.navName || ''),
        singleDigitalPrice: item.singleDigitalPrice || 0,
        singlePrintPrice: item.singlePrintPrice || 0,
        subscriptionDigitalPrice: item.subscriptionDigitalPrice || 0,
        subscriptionPrintPrice: item.subscriptionPrintPrice || 0
      }
    },
    loadMore() {
      this.visibleCount = Math.min(
        this.visibleCount + this.pageSize,
        this.magazineList.length
      )
    },
    goToViewer(emagazineCode, turnPage) {
      console.log('goToViewer', emagazineCode, turnPage)
      if (!emagazineCode) return
      let url = `${window.location.origin}/magazine/viewer?emagazineCode=${emagazineCode}`
      if (turnPage) {
        url += `&turnPage=${turnPage}`
      }
      window.open(url, '_blank')
    },

    // ==================== 购买杂志 ====================
    async buyMagazine(item) {
      const token = localStorage.getItem('token')
      if (!token) {
        window.location.href = `/login?redirect=${encodeURIComponent(this.$route.fullPath)}`
        return
      }

      try {
        const userType = localStorage.getItem('userType')
        const url = userType === 'personal' ? '/api/member/home/getUserInfo' : '/api/company/home/getCompanyInfo'
        
        const res = await request({
          url: url,
          method: 'post'
        })
        console.log('用户信息', res)
        if (res.code === 200 && res.data) {
          this.currentMagazine = item
          this.showBuyDialog = true
          this.initBuyInfo()
        } else {
          window.location.href = `/login?redirect=${encodeURIComponent(this.$route.fullPath)}`
        }
      } catch (error) {
        console.error('获取用户信息失败', error)
        window.location.href = `/login?redirect=${encodeURIComponent(this.$route.fullPath)}`
      }
    },

    initBuyInfo() {
      this.buyStep = 1
      this.productType = '本期'
      this.purchaseItemType = 'physical'
      this.singleDigitalPrice = this.currentMagazine.singleDigitalPrice || 0
      this.singlePrintPrice = this.currentMagazine.singlePrintPrice || 0
      this.subscriptionDigitalPrice = this.currentMagazine.subscriptionDigitalPrice || 0
      this.subscriptionPrintPrice = this.currentMagazine.subscriptionPrintPrice || 0
      this.quantity = 1
      this.orderNo = ''
      this.payLoading = false
      // 清空收货信息
      this.receiverName = ''
      this.receiverPhone = ''
      this.receiverAddress = ''
      this.receiverProvince = ''
      this.receiverCity = ''
      this.receiverDistrict = ''
      this.cityList = []
      this.districtList = []
      this.calculateTotalPrice()
    },

    calculateTotalPrice() {
      this.unitPrice = this.effectiveUnitPrice
      this.totalPrice = this.unitPrice * this.quantity
    },

    handleQuantityChange(delta) {
      const newQty = this.quantity + delta
      if (newQty >= 1 && newQty <= 99) {
        this.quantity = newQty
        this.calculateTotalPrice()
      }
    },

    async handlePayClick() {
      if (!this.canPay()) return

      if (!this.currentMagazine || !this.currentMagazine.emagazineCode) {
        this.$toast && this.$toast('缺少杂志编号，请刷新重试')
        return
      }
      const periodType = this.productType === '年刊' ? 2 : 1
      const mediaType = this.purchaseItemType === 'physical' ? 2 : 1
      const params = {
        emagazineCode: this.currentMagazine.emagazineCode,
        periodType,
        mediaType,
        quantity: this.quantity,
        receiverName: this.receiverName,
        receiverPhone: this.receiverPhone,
        receiverAddress: this.receiverAddress,
        receiverProvince: this.receiverProvince,
        receiverProvinceName: this.provinceName,
        receiverCity: this.receiverCity,
        receiverCityName: this.cityName,
        receiverDistrict: this.receiverDistrict,
        receiverDistrictName: this.districtName
      }
      try {
        this.payLoading = true
        const res = await request({
          url: '/api/order/createOrder',
          method: 'post',
          data: params
        })
        console.log('创建订单结果', res)
        if (res.code === 200 && res.data) {
          this.orderNo = res.data
          const wxRes = await request({
            url: '/api/order/wxUnifiedOrder',
            method: 'post',
            data: { orderNo: this.orderNo, type: 'web' }
          })
          if (wxRes.code === 200 && wxRes.data && wxRes.data.code_url) {
            this.buyStep = 2
            this.$nextTick(() => {
              this.generateQRCode(wxRes.data.code_url)
            })
            this.startPaymentCheck()
          } else {
            this.$toast && this.$toast(wxRes.msg || '获取支付二维码失败，请重试')
          }
        } else {
          this.$toast && this.$toast(res.msg || '创建订单失败，请重试')
        }
      } catch (error) {
        console.error('🚫 创建订单失败', error)
        const errorMsg = error.message || error.msg || (typeof error === 'string' ? error : '创建订单失败，请重试')
        if (window.alert) {
          window.alert(`❌ 订单创建失败\n\n原因：${errorMsg}`)
        }
      } finally {
        this.payLoading = false
      }
    },

    generateQRCode(url) {
      const container = this.$refs.qrcodeContainer
      if (!container) return
      container.innerHTML = ''
      const QRCode = require('qrcodejs2')
      new QRCode(container, {
        text: url,
        width: 200,
        height: 200,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.H
      })
      this.$nextTick(() => {
        const canvas = container.querySelector('canvas')
        if (!canvas) return
        const ctx = canvas.getContext('2d')
        const logo = new Image()
        logo.crossOrigin = 'anonymous'
        logo.src = 'https://res.wx.qq.com/a/wx_fed/assets/res/NTI4MWU5.ico'
        logo.onload = () => {
          const logoSize = 40
          const x = (canvas.width - logoSize) / 2
          const y = (canvas.height - logoSize) / 2
          ctx.fillStyle = '#ffffff'
          ctx.fillRect(x - 2, y - 2, logoSize + 4, logoSize + 4)
          ctx.drawImage(logo, x, y, logoSize, logoSize)
        }
      })
    },

    startPaymentCheck() {
      if (this.timer) clearInterval(this.timer)
      this.timer = setInterval(async () => {
        try {
          const res = await request({
            url: '/api/order/getPayStatus',
            method: 'post',
            data: { orderNo: this.orderNo }
          })
          if (res.code === 200 && res.data && res.data.payStatus === 1) {
            clearInterval(this.timer)
            this.timer = null
            this.buyStep = 3
          }
        } catch (error) {
          console.error('检查支付状态失败', error)
        }
      }, 1000)
    },

    goToMyOrders() {
      this.closeBuyDialog()
      this.$router.push('/my')
    },

    closeBuyDialog() {
      this.showBuyDialog = false
      this.buyStep = 1
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },

    // ==================== 省市区联动 ====================
    onProvinceChange() {
      this.receiverCity = ''
      this.receiverDistrict = ''
      this.districtList = []

      const province = this.regionData.find(p => p.value === this.receiverProvince)
      if (province && province.children) {
        this.cityList = province.children.map(c => ({
          value: c.value,
          label: c.label
        }))
      } else {
        this.cityList = []
      }
    },

    onCityChange() {
      this.receiverDistrict = ''

      const province = this.regionData.find(p => p.value === this.receiverProvince)
      if (province && province.children) {
        const city = province.children.find(c => c.value === this.receiverCity)
        if (city && city.children) {
          this.districtList = city.children.map(d => ({
            value: d.value,
            label: d.label
          }))
        } else {
          this.districtList = []
        }
      } else {
        this.districtList = []
      }
    },

    validatePhone() {
      this.receiverPhone = this.receiverPhone.replace(/[^0-9]/g, '')
    },
    async showOrderPayTipInfo() {
      try {
         const content = await request.post('/api/index/getOrderPayTip')
        this.orderPayTipContent = content.data || '<p>暂无支付说明</p>'
      } catch (err) {
       
        this.orderPayTipContent = '<p>加载失败，请稍后重试</p>'
      } 
    },
    canPay() {
      if (!this.receiverName.trim()) {
        alert('请输入收货人姓名')
        return false
      }
      if (!this.receiverPhone || this.receiverPhone.length !== 11) {
        alert('请输入正确的手机号码')
        return false
      }
      if (!this.receiverProvince) {
        alert('请选择所在地区')
        return false
      }
      if (!this.receiverAddress.trim()) {
        alert('请输入详细地址')
        return false
      }
      if (this.isRestrictedRegion) {
        alert('新疆、西藏地区暂不支持配送')
        return false
      }
      return true
    }
  }
}
</script>

<style scoped src="./assets/css/magazine.css"></style>

<style>
/* ===== 购买弹窗 ===== */
.mag-buy-dialog-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.mag-buy-dialog {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  min-width: 500px;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  animation: mag-dialog-slide-up 0.3s ease-out;
}
@keyframes mag-dialog-slide-up {
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
}
.mag-dialog-header {
  padding: 24px 24px 16px;
  text-align: center;
  border-bottom: 1px solid #eee;
}
.mag-dialog-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: bold;
  color: #333;
  line-height: 1.4;
}
.mag-dialog-content { padding: 24px; }
.mag-select-section { margin-bottom: 24px; }
.mag-label {
  display: block;
  font-size: 14px;
  color: #666;
  margin-bottom: 12px;
  font-weight: 500;
}
.mag-radio-group { display: flex; gap: 24px; }
.mag-radio-item { display: flex; align-items: center; cursor: pointer; }
.mag-radio-item input[type="radio"] {
  width: 18px; height: 18px; margin-right: 6px; accent-color: #A00000;
}
.mag-radio-text { font-size: 14px; color: #333; }
.mag-info-row {
  display: flex; justify-content: space-between; align-items: center;
  margin-bottom: 20px; padding: 12px 0;
}
.mag-info-label { font-size: 14px; color: #666; }
.mag-info-value { font-size: 16px; color: #333; font-weight: 500; }
.mag-quantity-section { margin-bottom: 20px; }
.mag-quantity-control { display: flex; align-items: center; gap: 16px; }
.mag-buy-dialog .mag-qty-btn {
  width: 32px; height: 32px;
  border: 1px solid #ddd; background: #f5f5f5;
  border-radius: 6px; font-size: 18px; color: #333;
  cursor: pointer; transition: all 0.2s;
  padding: 0; margin: 0;
}
.mag-buy-dialog .mag-qty-btn:hover:not(:disabled) {
  background: #A00000; color: #fff; border-color: #A00000;
}
.mag-buy-dialog .mag-qty-btn:disabled { opacity: 0.4; cursor: not-allowed; }
.mag-qty-value {
  font-size: 16px; color: #333; font-weight: 500;
  min-width: 40px; text-align: center;
}
.mag-total-section {
  display: flex; justify-content: space-between; align-items: center;
  padding: 20px; background: #fafafa; border-radius: 8px; margin-bottom: 24px;
}
.mag-total-label { font-size: 16px; color: #666; }
.mag-total-value { font-size: 24px; color: #A00000; font-weight: bold; }

/* 运费提示 */
.mag-shipping-tip {
  font-size: 13px;
  color: #999;
  text-align: right;
  margin-top: -16px;
  margin-bottom: 24px;
  padding-right: 4px;
}

/* ===== 收货地址区域 ===== */
.mag-address-section {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.mag-input-row,
.mag-district-section {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

/* textarea 行顶部对齐 */
.mag-input-row.mag-input-row-textarea {
  align-items: flex-start;
}

/* 收货地址区域内的 label 固定宽度、右对齐 */
.mag-address-section .mag-label {
  display: inline-block;
  width: 100px;
  flex-shrink: 0;
  font-size: 14px;
  color: #333;
  font-weight: 400;
  margin-bottom: 0;
  line-height: 40px;
  text-align: right;
  padding-right: 12px;
  box-sizing: border-box;
}

/* textarea 那一行的 label 顶部对齐 */
.mag-input-row.mag-input-row-textarea .mag-label {
  line-height: 1.4;
  padding-top: 10px;
}

/* 输入框占据剩余空间 */
.mag-input-text,
.mag-input-textarea {
  flex: 1;
  width: auto;
  box-sizing: border-box;
}

.mag-input-text {
  padding: 0 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.2s;
  height: 40px;
}

.mag-input-text:focus {
  outline: none;
  border-color: #A00000;
  box-shadow: 0 0 0 2px rgba(160, 0, 0, 0.1);
}

.mag-input-textarea {
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  resize: vertical;
  font-family: inherit;
  min-height: 80px;
}
.mag-pay-tip {
  font-size: 14px;
  color: #666;
  text-align: center;
  margin-bottom: 16px;
}
.mag-input-textarea:focus {
  outline: none;
  border-color: #A00000;
  box-shadow: 0 0 0 2px rgba(160, 0, 0, 0.1);
}

/* 省市区选择行 */
.mag-district-section {
  flex-wrap: wrap; /* 允许警告文字换行显示 */
}
.mag-district-section > .mag-label {
  line-height: 40px;
}
.mag-district-row {
  display: flex;
  gap: 12px;
  flex: 1;
  align-items: center;
  min-width: 0;
}

.mag-district-select {
  flex: 1;
  min-width: 0;
  padding: 0 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s;
  height: 40px;
  box-sizing: border-box;
}

.mag-district-select:hover:not(:disabled) {
  border-color: #A00000;
}

.mag-district-select:focus {
  outline: none;
  border-color: #A00000;
  box-shadow: 0 0 0 2px rgba(160, 0, 0, 0.1);
}

.mag-district-select:disabled {
  background: #f5f5f5;
  color: #999;
  cursor: not-allowed;
}

/* 警告文字：占满整行，与输入框左对齐 */
.mag-warning-text {
  flex-basis: 100%;
  margin-top: 12px;
  margin-left: 100px;
  padding: 10px 12px;
  background: #FFF3CD;
  border-left: 4px solid #FFCC00;
  color: #856404;
  font-size: 13px;
  border-radius: 4px;
  box-sizing: border-box;
}

/* 支付按钮 */
.mag-buy-dialog .mag-pay-btn {
  width: 100%; height: 48px;
  background: linear-gradient(135deg, #A00000, #700000);
  color: #fff; border: none; border-radius: 8px;
  font-size: 16px; font-weight: bold; cursor: pointer; transition: all 0.25s;
  padding: 0 18px; margin: 0;
  margin-top: 12px;
}
.mag-buy-dialog .mag-pay-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #C00000, #900000);
  box-shadow: 0 4px 20px rgba(160, 0, 0, 0.4);
}
/* 禁用态：变灰 */
.mag-buy-dialog .mag-pay-btn:disabled {
  background: #ccc;
  color: #fff;
  cursor: not-allowed;
  box-shadow: none;
  opacity: 0.7;
}

.mag-buy-dialog .mag-back-btn {
  width: 100%; height: 48px;
  background: transparent; color: #666;
  border: 1px solid #ddd; border-radius: 8px;
  font-size: 14px; cursor: pointer; transition: all 0.2s; margin-top: 12px;
  padding: 0 18px; outline: none;
}
.mag-buy-dialog .mag-back-btn:hover { background: #f5f5f5; color: #333; border-color: #ccc; }
.mag-buy-dialog .mag-back-btn:active { opacity: 1; }

.mag-buy-dialog-success {
  background: #fff; border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  min-width: 420px; max-width: 500px; overflow: hidden;
  animation: mag-dialog-slide-up 0.3s ease-out;
}
.mag-buy-dialog-success .mag-dialog-content { padding: 48px 32px; text-align: center; }
.mag-success-icon { margin-bottom: 24px; }
.mag-success-title { margin: 0 0 16px; font-size: 24px; font-weight: bold; color: #333; }
.mag-success-desc { margin: 0; font-size: 14px; color: #999; line-height: 1.8; }
.mag-success-link { color: #A00000; cursor: pointer; font-weight: 500; text-decoration: underline; }
.mag-success-link:hover { color: #C00000; }

.mag-order-summary {
  margin-bottom: 24px; padding: 16px;
  background: #f9f9f9; border-radius: 8px; text-align: center;
}
.mag-order-summary p { margin: 0; font-size: 14px; color: #666; line-height: 1.6; }
.mag-qrcode-container { text-align: center; }
.mag-qrcode-box {
  width: 220px; height: 220px; margin: 0 auto 24px;
  border: 2px dashed #A00000; border-radius: 8px;
  display: flex; align-items: center; justify-content: center; background: #fafafa;
}
.mag-qrcode-placeholder { display: flex; flex-direction: column; align-items: center; gap: 16px; }
.mag-qrcode-placeholder span { font-size: 14px; color: #999; }
.mag-pay-amount { font-size: 32px; color: #A00000; font-weight: bold; }

.mag-dialog-fade-enter-active, .mag-dialog-fade-leave-active { transition: opacity 0.3s ease; }
.mag-dialog-fade-enter-from, .mag-dialog-fade-leave-to { opacity: 0; }

/* ===== 骨架屏 ===== */
.skeleton-list {
  width: 100%;
}

.skeleton-item {
  pointer-events: none;
}

.skeleton-anim {
  background: linear-gradient(
    90deg,
    #f0f0f0 25%,
    #e0e0e0 37%,
    #f0f0f0 63%
  );
  background-size: 400% 100%;
  animation: skeleton-shimmer 1.4s ease infinite;
}

@keyframes skeleton-shimmer {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}

/* 封面骨架 */
.skeleton-cover {
  width: 180px;
  height: 240px;
  border-radius: 4px;
  flex-shrink: 0;
}

/* 标题骨架 */
.skeleton-title {
  width: 40%;
  height: 24px;
  border-radius: 4px;
  margin-bottom: 20px;
}

/* 目录行骨架 */
.skeleton-row-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
}

.skeleton-row {
  width: 100%;
  height: 36px;
  border-radius: 4px;
}

/* 品牌标题骨架 */
.skeleton-brand-title {
  width: 80px;
  height: 18px;
  border-radius: 4px;
  margin-bottom: 12px;
}

/* 品牌列表骨架 */
.skeleton-brand-list {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.skeleton-brand {
  width: 80px;
  height: 28px;
  border-radius: 4px;
}

/* 右侧按钮骨架 */
.skeleton-btn {
  width: 100px;
  height: 100px;
  border-radius: 8px;
}
</style>